import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=184cdad3&scoped=true&"
import script from "./AccountButton.vue?vue&type=script&lang=js&"
export * from "./AccountButton.vue?vue&type=script&lang=js&"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=184cdad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cdad3",
  null
  
)

export default component.exports